/* ============================================================
   ETCHCRAFT STONE SERIES — PRODUCT TEMPLATE JS
   File: assets/stone-series.js
   ============================================================ */

(function() {
  'use strict';

  // ---- 0. PAGE MARKER & SECTION TAGGING ----
  // Add a marker class to <body> so our CSS can hide leftover theme content.
  // Then tag each of our sections so they're excluded from the hide rule.
  function initPageMarkers() {
    // Only run if our hero section is present (= we're on a Stone Series page)
    if (!document.querySelector('.ess-hero')) return;

    document.body.classList.add('ess-stone-page');

    // Tag every shopify-section that contains our content
    var ourSelectors = [
      '.ess-hero',
      '.ess-stone-story',
      '.ess-chakra-section',
      '.ess-ritual',
      '.ess-details',
      '.ess-reviews',
      '.ess-related'
    ];
    ourSelectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        var section = el.closest('.shopify-section') || el.parentElement;
        if (section) section.setAttribute('data-ess-section', '');
      });
    });

    // Also tag the assets-loader section if present
    document.querySelectorAll('.shopify-section').forEach(function(s) {
      var inner = s.innerHTML || '';
      if (inner.indexOf('window.essProductData') !== -1) {
        s.setAttribute('data-ess-section', '');
      }
    });

    // ---- NUCLEAR OPTION: Find and remove leftover theme accordions ----
    // Strategy: find an element that contains BOTH "Description" AND
    // "Visit Our Stores" (or other known leftovers). That's almost
    // certainly the accordion container we want to nuke.
    var leftoverHeadings = [
      'Description',
      'What People Immortalize in Jewelry',
      'What People Immortalize in Jewellery',
      'Visit Our Stores',
      'Customer Reviews',
      'Shipping Information',
      'Care Instructions',
      'Returns',
      'Why Choose Us',
      'About the Product'
    ];

    function findLeftoverContainer() {
      // Look for any element on the page that contains 2 or more leftover headings.
      // Only consider elements OUTSIDE our marked sections.
      var allElements = document.querySelectorAll('div, section, aside, article');
      var bestMatch = null;
      var bestScore = 0;

      for (var i = 0; i < allElements.length; i++) {
        var el = allElements[i];
        // Skip if it's inside one of our sections
        if (el.closest('[data-ess-section]')) continue;
        if (el.closest('.ess-hero, .ess-stone-story, .ess-chakra-section, .ess-ritual, .ess-details, .ess-reviews, .ess-related')) continue;
        // Skip header / footer / nav / cart drawer
        if (el.closest('header, footer, nav, [class*="cart-drawer"], [class*="Cart"]')) continue;

        var text = (el.textContent || '');
        if (text.length < 20 || text.length > 5000) continue; // sanity check

        var score = 0;
        for (var j = 0; j < leftoverHeadings.length; j++) {
          if (text.indexOf(leftoverHeadings[j]) !== -1) score++;
        }

        // Need at least 2 matches to be confident this is the accordion block
        if (score >= 2 && score > bestScore) {
          bestScore = score;
          bestMatch = el;
        }
      }

      return bestMatch;
    }

    function removeLeftovers() {
      // Strategy A: find the smallest container that has 2+ leftover headings
      var leftover = findLeftoverContainer();

      if (leftover) {
        // Walk DOWN from the matched element to find the tightest container.
        // We want the deepest element that still contains 2+ matches.
        var refined = leftover;
        var children = leftover.children;
        for (var k = 0; k < children.length; k++) {
          var child = children[k];
          var childText = (child.textContent || '');
          var childScore = 0;
          for (var m = 0; m < leftoverHeadings.length; m++) {
            if (childText.indexOf(leftoverHeadings[m]) !== -1) childScore++;
          }
          if (childScore >= 2) {
            refined = child; // This child still has all matches — refine to it
            break;
          }
        }
        refined.style.setProperty('display', 'none', 'important');
        refined.setAttribute('data-ess-removed', 'leftover-accordion');
      }

      // Strategy B: also kill individual headings/triggers by exact text match
      // (in case strategy A missed a single one)
      var candidates = document.querySelectorAll(
        'h1, h2, h3, h4, h5, h6, button, summary, [role="button"], a'
      );
      candidates.forEach(function(el) {
        if (el.closest('[data-ess-section]')) return;
        if (el.closest('.ess-hero, .ess-stone-story, .ess-chakra-section, .ess-ritual, .ess-details, .ess-reviews, .ess-related')) return;
        if (el.closest('header, footer, nav')) return;

        var text = (el.textContent || '').trim();
        if (!text || text.length > 60) return;

        var match = leftoverHeadings.some(function(pattern) {
          return text === pattern;
        });

        if (match) {
          // Walk UP looking for the accordion item container
          var container = el;
          for (var hops = 0; hops < 6; hops++) {
            if (!container.parentElement) break;
            container = container.parentElement;
            // Stop if we hit something we shouldn't remove
            if (container.tagName === 'BODY' || container.tagName === 'MAIN') break;
            if (container.closest('[data-ess-section]')) return;
          }
          if (container && container !== document.body && !container.closest('[data-ess-section]')) {
            container.style.setProperty('display', 'none', 'important');
            container.setAttribute('data-ess-removed', 'leftover-heading');
          }
        }
      });
    }

    removeLeftovers();
    setTimeout(removeLeftovers, 300);
    setTimeout(removeLeftovers, 1000);
    setTimeout(removeLeftovers, 2500);

    // Watch for any new content added to the page (e.g. lazy-loaded accordions)
    if (window.MutationObserver) {
      var observer = new MutationObserver(function(mutations) {
        var hasAddedNodes = mutations.some(function(m) {
          return m.addedNodes && m.addedNodes.length > 0;
        });
        if (hasAddedNodes) {
          // Debounce to avoid running too often
          clearTimeout(window._essObserverDebounce);
          window._essObserverDebounce = setTimeout(removeLeftovers, 200);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      // Stop observing after 10 seconds — by then everything should be settled
      setTimeout(function() { observer.disconnect(); }, 10000);
    }
  }

  // ---- 1. GALLERY THUMBNAILS ----
  function initGallery() {
    var thumbs = document.querySelectorAll('.ess-thumb');
    var slides = document.querySelectorAll('.ess-slide');
    if (!thumbs.length || !slides.length) return;

    thumbs.forEach(function(t) {
      t.addEventListener('click', function() {
        var idx = parseInt(t.dataset.thumbIndex);
        thumbs.forEach(function(x) { x.classList.remove('is-active'); });
        slides.forEach(function(x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var slide = document.querySelector('.ess-slide[data-slide-index="' + idx + '"]');
        if (slide) slide.classList.add('is-active');
      });
    });
  }

  // ---- 2. QTY STEPPER ----
  function initQty() {
    document.querySelectorAll('.ess-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('.ess-qty-input');
        var step = parseInt(btn.dataset.qty) || 1;
        var v = parseInt(input.value) || 1;
        v = Math.max(1, v + step);
        input.value = v;
      });
    });
  }

  // ---- 3. VARIANT PICKER ----
  // Reads selected option pills, finds the matching variant, updates price/select/URL
  function initVariants() {
    var form = document.getElementById('product-form-stone');
    if (!form) return;
    var select = form.querySelector('.ess-variant-select');
    if (!select) return;

    // Build a map of variant data from the JSON in window.essProductData (set below)
    var product = window.essProductData;
    if (!product) return;

    function getSelectedOptions() {
      var opts = [];
      document.querySelectorAll('[data-option-index]').forEach(function(group) {
        var idx = parseInt(group.dataset.optionIndex);
        var active = group.querySelector('.ess-option-pill.is-active');
        opts[idx] = active ? active.dataset.optionValue : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function(v) {
        return v.options.every(function(o, i) { return o === opts[i]; });
      });
    }

    function updatePrice(variant) {
      if (!variant) return;
      // Format price using shop currency (Shopify formats already in money_format)
      var priceTargets = document.querySelectorAll('[data-price-target]');
      priceTargets.forEach(function(el) {
        el.textContent = formatMoney(variant.price);
      });
      var compareTargets = document.querySelectorAll('[data-compare-target]');
      compareTargets.forEach(function(el) {
        el.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';
      });
      // Mobile sticky
      var ms = document.querySelector('.ess-mobile-sticky-price');
      if (ms) ms.textContent = formatMoney(variant.price);
      var mso = document.querySelector('.ess-mobile-sticky-original');
      if (mso && variant.compare_at_price) mso.textContent = formatMoney(variant.compare_at_price);

      // Disable add-to-cart if unavailable
      var btn = form.querySelector('.ess-add-cart');
      if (btn) {
        btn.disabled = !variant.available;
        btn.querySelector('[data-cart-text]').innerHTML =
          variant.available
            ? 'Add to Cart · ' + formatMoney(variant.price)
            : 'Sold Out';
      }
    }

    function updateUrl(variantId) {
      var url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }

    function formatMoney(cents) {
      // Use Shopify's window.theme.moneyFormat if available, else fallback
      var format = (window.theme && window.theme.moneyFormat) || '₹{{amount}}';
      var amount = (cents / 100).toFixed(2);
      // Strip trailing .00
      if (amount.endsWith('.00')) amount = amount.slice(0, -3);
      return format.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    // Wire up clicks on option pills
    document.querySelectorAll('[data-option-index]').forEach(function(group) {
      group.querySelectorAll('.ess-option-pill').forEach(function(pill) {
        pill.addEventListener('click', function() {
          group.querySelectorAll('.ess-option-pill').forEach(function(p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          // Update label
          var idx = parseInt(group.dataset.optionIndex);
          var label = document.querySelector('.ess-option-selected[data-option-value="' + idx + '"]');
          if (label) label.textContent = pill.dataset.optionValue;

          // Find matching variant
          var opts = getSelectedOptions();
          var variant = findVariant(opts);
          if (variant) {
            select.value = variant.id;
            form.querySelector('input[name="id"]').value = variant.id;
            updatePrice(variant);
            updateUrl(variant.id);
          }
        });
      });
    });
  }

  // ---- 4. ACCORDION (already wired per-section, but harmless backup) ----
  function initAccordion() {
    document.querySelectorAll('.ess-acc-trigger').forEach(function(btn) {
      if (btn.dataset.essBound) return;
      btn.dataset.essBound = '1';
      btn.addEventListener('click', function() {
        var item = btn.parentElement;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
      });
    });
  }

  // ---- 5. MOBILE STICKY → submit form ----
  function initMobileSticky() {
    var btn = document.querySelector('[data-mobile-add]');
    var form = document.getElementById('product-form-stone');
    if (!btn || !form) return;
    btn.addEventListener('click', function() {
      // Submit add-to-cart form
      form.querySelector('button[name="add"]').click();
    });
  }

  // ---- 5b. WHATSAPP / CHAT WIDGET REPOSITIONER ----
  // Some chat apps inject elements with unknown class names. This finds any
  // fixed-position element in the bottom-right corner and pushes it up
  // when the mobile sticky bar is visible.
  function initChatWidgetReposition() {
    if (window.innerWidth > 768) return;
    var stickyBar = document.querySelector('.ess-mobile-sticky');
    if (!stickyBar) return;

    var STICKY_HEIGHT = 84; // Cart bar height + breathing room

    function adjustWidgets() {
      // Find all fixed-position elements that look like floating chat buttons
      var elements = document.querySelectorAll('body > *, body > * > *');
      elements.forEach(function(el) {
        if (el === stickyBar || stickyBar.contains(el)) return;
        var styles = window.getComputedStyle(el);
        if (styles.position !== 'fixed') return;

        var rect = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var vw = window.innerWidth;

        // Target: small (~50-90px square) elements in bottom-right area
        var isFloatingButton =
          rect.width < 100 && rect.width > 30 &&
          rect.height < 100 && rect.height > 30 &&
          rect.right > vw - 120 &&         // right side
          rect.bottom > vh - 140 &&        // bottom area
          rect.bottom < vh + 20;           // not above the fold

        // Also catch chat iframes
        var isChatIframe =
          el.tagName === 'IFRAME' &&
          rect.bottom > vh - 200 &&
          rect.right > vw - 200;

        if (isFloatingButton || isChatIframe) {
          if (!el.dataset.essOriginalBottom) {
            el.dataset.essOriginalBottom = styles.bottom || '20px';
          }
          // Shift up only if not already shifted
          var currentBottom = parseInt(styles.bottom) || 0;
          if (currentBottom < STICKY_HEIGHT) {
            el.style.setProperty('bottom', STICKY_HEIGHT + 'px', 'important');
            el.style.setProperty('transition', 'bottom 0.25s ease', 'important');
          }
        }
      });
    }

    // Run on load, and again after delays to catch widgets that load late
    adjustWidgets();
    setTimeout(adjustWidgets, 1000);
    setTimeout(adjustWidgets, 3000);
    setTimeout(adjustWidgets, 6000);

    // Also re-check on resize
    window.addEventListener('resize', adjustWidgets);
  }

  // ---- 6. SCROLL REVEAL ----
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('is-revealed'); });
    }, { threshold: 0.15 });
    document.querySelectorAll('.ess-section-rule, .ess-ritual-step, .ess-review-card, .ess-product-card').forEach(function(el) {
      el.classList.add('ess-reveal');
      observer.observe(el);
    });
  }

  // ---- INIT ALL ----
  function init() {
    initPageMarkers();
    initGallery();
    initQty();
    initVariants();
    initAccordion();
    initMobileSticky();
    initChatWidgetReposition();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
